import React from 'react';
import { Container } from 'Core/components/Layout';

export default function Header({ title, subtitle, branding = 'default' }) {
  
  const finalBranding = branding || 'default';
  const classes = {
    default: 'bg-primary text-white border-b-8 border-orange-500',
    flexHeight: subtitle ? 'h-full' : '',
    subtitleColor: 'text-gray-300',
  };
  return (
    <header className={`${classes[finalBranding]} px-4 mb-4 h-16`}>
      <Container className={`!mb-0 !h-full !px-4 !flex !items-center !justify-between`}>
        <div className={`${classes.flexHeight} flex flex-col py-2`}>
          <h2 className="m-0" data-testid="header-headline">
            {title}
          </h2>
          <div className={`${classes.subtitleColor} text-sm`}>{subtitle}</div>
        </div>
      </Container>
    </header>
  );
}
